export const fmtEUR = (value) =>
    new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR"}).format(value ?? 0);

export const parseDate = (value) => (value ? new Date(value) : null);
export const isPaid = (inv) => Boolean(inv?.paid);
export const sum = (arr) => arr.reduce((acc, entry) => acc + (Number(entry) || 0), 0);

export const monthKey = (date) => {
    const parsed = date instanceof Date ? date : parseDate(date);
    if (!parsed) return "";
    return `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, "0")}`;
};

export const safeInvoiceTotal = (inv) => Number(inv?.totalGross ?? inv?.totalNet ?? 0);

export const safeIncomeAmount = (inc) => {
    if (inc?.isEuService) {
        return Number(inc?.netAmount ?? inc?.grossAmount ?? inc?.amount ?? 0);
    }
    return Number(inc?.amount ?? inc?.grossAmount ?? inc?.netAmount ?? 0);
};

export const safeExpenseAmount = (exp) => {
    if (exp?.isEuService) {
        return Number(exp?.netAmount ?? exp?.grossAmount ?? 0);
    }
    return Number(exp?.grossAmount ?? exp?.netAmount ?? 0);
};

export const extractArray = (res) => {
    const data = res?.data ?? res;
    if (Array.isArray(data)) {
        return data;
    }
    if (data && Array.isArray(data.content)) {
        return data.content;
    }
    return [];
};

// Disable dragging on interactive controls so clicks remain usable inside the cards
export const DRAGGABLE_CANCEL_SELECTORS = [
    ".no-drag",
    ".MuiButtonBase-root",
    ".MuiChip-root",
    ".MuiIconButton-root",
    ".MuiInputBase-root",
    "a",
    "button",
    "input",
    "select",
    "textarea",
    '[role="button"]',
].join(", ");

export const IDS = [
    "kpi-open",
    "kpi-overdue",
    "kpi-income",
    "kpi-expense",
    "chart-distribution",
    "chart-cashflow",
    "table-due",
    "quick-links",
];

export const breakpoints = {lg: 1200, md: 900, sm: 600, xs: 480, xxs: 0};
export const cols = {lg: 4, md: 4, sm: 4, xs: 2, xxs: 1};

export const initialLayouts = () => {
    const lg = [
        {i: "kpi-open", x: 0, y: 0, w: 2, h: 2},
        {i: "kpi-overdue", x: 2, y: 0, w: 2, h: 2},
        {i: "kpi-income", x: 0, y: 2, w: 2, h: 2},
        {i: "kpi-expense", x: 2, y: 2, w: 2, h: 2},
        {i: "chart-distribution", x: 0, y: 4, w: 2, h: 3},
        {i: "chart-cashflow", x: 2, y: 4, w: 2, h: 3},
        {i: "table-due", x: 0, y: 7, w: 4, h: 4},
        {i: "quick-links", x: 0, y: 11, w: 4, h: 2},
    ];
    const md = lg.map((layout) => ({...layout}));
    const sm = [
        {i: "kpi-open", x: 0, y: 0, w: 2, h: 2},
        {i: "kpi-overdue", x: 2, y: 0, w: 2, h: 2},
        {i: "kpi-income", x: 0, y: 2, w: 2, h: 2},
        {i: "kpi-expense", x: 2, y: 2, w: 2, h: 2},
        {i: "chart-distribution", x: 0, y: 4, w: 2, h: 3},
        {i: "chart-cashflow", x: 2, y: 4, w: 2, h: 3},
        {i: "table-due", x: 0, y: 7, w: 4, h: 4},
        {i: "quick-links", x: 0, y: 11, w: 4, h: 2},
    ];
    const xs = [
        {i: "kpi-open", x: 0, y: 0, w: 1, h: 2},
        {i: "kpi-overdue", x: 1, y: 0, w: 1, h: 2},
        {i: "kpi-income", x: 0, y: 2, w: 1, h: 2},
        {i: "kpi-expense", x: 1, y: 2, w: 1, h: 2},
        {i: "chart-distribution", x: 0, y: 4, w: 2, h: 3},
        {i: "chart-cashflow", x: 0, y: 7, w: 2, h: 3},
        {i: "table-due", x: 0, y: 10, w: 2, h: 5},
        {i: "quick-links", x: 0, y: 15, w: 2, h: 2},
    ];
    const xxs = [
        {i: "kpi-open", x: 0, y: 0, w: 1, h: 2},
        {i: "kpi-overdue", x: 0, y: 2, w: 1, h: 2},
        {i: "kpi-income", x: 0, y: 4, w: 1, h: 2},
        {i: "kpi-expense", x: 0, y: 6, w: 1, h: 2},
        {i: "chart-distribution", x: 0, y: 8, w: 1, h: 3},
        {i: "chart-cashflow", x: 0, y: 11, w: 1, h: 3},
        {i: "table-due", x: 0, y: 14, w: 1, h: 6},
        {i: "quick-links", x: 0, y: 20, w: 1, h: 2},
    ];
    return {lg, md, sm, xs, xxs};
};

export const STATIC_LAYOUTS = initialLayouts();
